import React from 'react';
import PropTypes from 'prop-types';
import Literal from 'components/literal';
import './styles.scss';

const CrudSection = (props) => {
    const { titleKey, children, className } = props;
    const classNames = ['crud-section'];
    if (className) classNames.push(className);

    return (
        <div className={classNames.join(' ')}>
            <div className="crud-section-title">
                <Literal literal={titleKey} />
            </div>
            <div className="crud-section-body">{children}</div>
        </div>
    );
};

CrudSection.propTypes = {
    titleKey: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default CrudSection;
